<div class="page-header" id="banner">
  <div class="row">
    <div class="col">
      <h1><a routerLink="/fleet">Fleet</a> > {{vehicle?.name}}</h1>
    </div>
  </div>
</div>

@if (vehicle) {
  <form>
    <div class="form-group">
      <label for="name">Name</label>
      <input type="text" class="form-control form-control-lg" [class.is-invalid]="nameField.invalid && (nameField.dirty || nameField.touched)"
        id="name" name="name" [(ngModel)]="vehicle.name" required #nameField="ngModel">
      @if (nameField.invalid && (nameField.dirty || nameField.touched)) {
        <div class="invalid-feedback">
          @if (nameField.errors.required) {
            <div>Please enter a name for the vehicle.</div>
          }
        </div>
      }
    </div>
    <div class="form-group">
      <label for="mileage">Mileage</label>
      <input type="number" class="form-control form-control-lg" id="mileage" name="mileage" [(ngModel)]="vehicle.mileage" placeholder="123456">
    </div>
    <div class="form-group">
      <div class="custom-control custom-switch">
        <input type="checkbox" class="custom-control-input" id="shared" name="shared" [(ngModel)]="vehicle.shared" >
        <label class="custom-control-label" for="shared">Share this vehicle's maintenance</label>
      </div>
    </div>
    <div class="form-group">
      <label for="vin">VIN <span class="text-muted">(optional)</span></label>
      <input type="text" class="form-control form-control-lg" [class.is-invalid]="vinField.invalid && (vinField.dirty || vinField.touched)"
        id="vin" name="vin" [(ngModel)]="vehicle.vin" placeholder="1HGBH41JXMN109186" maxlength="17"
        pattern="[A-HJ-NPR-Z0-9]{17}" #vinField="ngModel">
      @if (vinField.invalid && (vinField.dirty || vinField.touched)) {
        <div class="invalid-feedback">
          @if (vinField.errors?.['pattern']) {
            <div>VIN must be exactly 17 alphanumeric characters (no I, O, or Q).</div>
          }
        </div>
      }
    </div>
    <button class="btn btn-primary" (click)="submit()" [disabled]="nameField.invalid || vinField.invalid">Submit</button>
    <a class="btn" routerLink="/vehicle/{{vehicle.id}}">Cancel</a>
  </form>
}

@if (!vehicle) {
  <p>Loading...</p>
}